export default "__VITE_ASSET__wqrAVcKq__"